import React from 'react';
import protoaiData from '../data/protoai-data.json';

// Original Appiya Components
import Heroarea from './components-home/Heroarea';
import Feature from './components-home/Feature';
import FeatureOne from './components-home/FeatureOne';
import FeatureTwo from './components-home/FeatureTwo';
import Pricing from './components-home/Pricing';

// ProtoAI Components
import ContactSection from './components-protoai/ContactSection';

const Home = () => {
    // Map protoAI data to Appiya component structures
    const heroData = {
        ...protoaiData.hero,
        imgurl1: protoaiData.hero.imgurl
    };

    const problemData = {
        ...protoaiData.problem,
        sectiontitle: protoaiData.problem.title,
        featurescontent: protoaiData.problem.cards
    };

    const solutionData = {
        sectiontitle: protoaiData.solution.title,
        subtitle: protoaiData.solution.subtitle,
        content: protoaiData.solution.content,
        highlight: protoaiData.solution.highlight,
        description: protoaiData.solution.description,
        imgurl: protoaiData.solution.imgurl
    };

    const valueData = {
        sectiontitle: protoaiData.valueProposition.title,
        subtitle: protoaiData.valueProposition.subtitle,
        values: protoaiData.valueProposition.values
    };

    // ホーム専用の新規コンテンツ
    const homeFeaturesData = {
        ...protoaiData.homeFeatures
    };

    const homeAchievementsData = {
        ...protoaiData.homeAchievements
    };

    const homeCasesData = {
        ...protoaiData.homeCases
    };

    const homeFaqData = {
        ...protoaiData.homeFaq
    };

    const pricingData = {
        sectiontitle: protoaiData.pricing?.pageTitle || "料金プラン",
        tables: protoaiData.pricing?.plans?.map(plan => ({
            title: plan.title,
            price: plan.price,
            currency: "",
            duration: plan.unit,
            features: plan.features || [],
            url: plan.url || "#"
        })) || []
    };

    return (
      <div>
        {/* Hero Section with white text for home page */}
        <Heroarea data={heroData} isHomePage={true} />

        {/* Problem Section using Feature component with cards */}
        <Feature data={problemData} className="bg-light" fullWidth={true} hideImages={true} />

        {/* Solution Section using FeatureOne component */}
        <FeatureOne data={solutionData} />

        {/* Value Proposition using FeatureTwo component */}
        <FeatureTwo data={valueData} />

        {/* ホーム専用: 選ばれる理由セクション */}
        <Feature data={homeFeaturesData} className="bg-light" fullWidth={true} hideImages={true} />

        {/* ホーム専用: 実績セクション */}
        <Feature data={homeAchievementsData} fullWidth={true} hideImages={true} />

        {/* ホーム専用: お客様の声セクション */}
        <Feature data={homeCasesData} className="bg-light" fullWidth={true} hideImages={true} />

        {/* ホーム専用: FAQセクション */}
        <Feature data={homeFaqData} fullWidth={true} hideImages={true} />

        {/* Pricing Section with background */}
        <Pricing data={pricingData} />

        {/* Contact Section - 法人向けフォーム */}
        <ContactSection data={protoaiData.contact} />
      </div>
    );
}



export default Home;
